import { render } from "./MainTypeOfUsers.vue?vue&type=template&id=32ae0bcb&scoped=true"
import script from "./MainTypeOfUsers.vue?vue&type=script&lang=js"
export * from "./MainTypeOfUsers.vue?vue&type=script&lang=js"

import "./MainTypeOfUsers.vue?vue&type=style&index=0&id=32ae0bcb&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ae0bcb"]])

export default __exports__